import "./ServiceCardStyles.css"
import ServiceCard from "./ServiceCard"


import React from 'react'
import { useTranslation } from "react-i18next"


const Service = () => {

    const { t } = useTranslation()
    const ServiceCardData = t('services.ServiceCardData', { returnObjects: true })

  return (
      <section className="service-section">
        <div className="work-container">
            <h1 className="service-heading">{t('services.title')}</h1>
            <hr className="small-hr"></hr>
            <div className="service-container">
                {ServiceCardData.map((val,ind)=>{
                    return(<ServiceCard 
                        key={ind}
                        imgsrc={val.imgsrc}
                        title={val.title}
                        text={val.text}
                        view={val.view}
                        />
                        )
                })}      
            </div>
        </div>
       </section>   
  )
}

export default Service